module.exports = __webpack_public_path__ + "static/media/Buffer.09f9e40c.svg";